import React, { useEffect, useState } from 'react';

const TestCorsRequest: React.FC = () => {
  const [result, setResult] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const testCorsRequest = () => {
    setIsLoading(true);
    setResult('');
    setError('');
    
    const url = 'https://www.takagi-global.com/wp-admin/profile.php';
    
    console.log('Sending request to:', url);
    
    fetch(url, {
      method: 'GET',
      credentials: 'include', // To send cookies
      headers: {
        'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
        'Accept-Language': 'en-US,en;q=0.9,ja;q=0.8,vi;q=0.7',
        'Cache-Control': 'max-age=0',
        'Referer': 'https://www.takagi-global.com/en/',
        'Sec-Fetch-Dest': 'document',
        'Sec-Fetch-Mode': 'navigate',
        'Sec-Fetch-Site': 'same-origin',
        'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/138.0.0.0 Safari/537.36'
      }
    })
    .then(response => {
      console.log('Response status:', response.status);
      return response.text();
    })
    .then(data => {
      console.log('Data received length:', data.length);
      setResult(data.substring(0, 500) + '...');
      setIsLoading(false);
    })
    .catch(error => {
      console.error('Error:', error);
      setError(error.toString());
      setIsLoading(false);
    });
  };

  // Testing with XMLHttpRequest instead of fetch
  const testWithXHR = () => {
    setIsLoading(true);
    setResult('');
    setError('');
    
    const xhr = new XMLHttpRequest();
    xhr.withCredentials = true; // To send cookies
    
    xhr.open('GET', 'https://www.takagi-global.com/wp-admin/profile.php', true);
    
    // Set up headers
    xhr.setRequestHeader('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7');
    xhr.setRequestHeader('Accept-Language', 'en-US,en;q=0.9,ja;q=0.8,vi;q=0.7');
    xhr.setRequestHeader('Cache-Control', 'max-age=0');
    xhr.setRequestHeader('Referer', 'https://www.takagi-global.com/en/');
    
    xhr.onload = function() {
      if (xhr.status === 200) {
        setResult(xhr.responseText.substring(0, 500) + '...');
      } else {
        setError(`Error: ${xhr.status} - ${xhr.statusText}`);
      }
      setIsLoading(false);
    };
    
    xhr.onerror = function() {
      setError('Request failed. CORS error or network issue.');
      setIsLoading(false);
    };
    
    xhr.send();
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">CORS Request Test</h1>
      
      <div className="flex space-x-4 mb-6">
        <button 
          onClick={testCorsRequest}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded disabled:bg-gray-400"
          disabled={isLoading}
        >
          Test with Fetch
        </button>
        
        <button 
          onClick={testWithXHR}
          className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded disabled:bg-gray-400"
          disabled={isLoading}
        >
          Test with XMLHttpRequest
        </button>
      </div>
      
      {isLoading && <div className="text-gray-700">Loading...</div>}
      
      {error && (
        <div className="mt-4 p-4 bg-red-100 border border-red-300 rounded">
          <h2 className="font-bold text-red-700">Error:</h2>
          <pre className="whitespace-pre-wrap overflow-auto max-h-60">{error}</pre>
        </div>
      )}
      
      {result && (
        <div className="mt-4">
          <h2 className="font-bold">Response:</h2>
          <div className="mt-2 p-4 bg-gray-100 border border-gray-300 rounded">
            <pre className="whitespace-pre-wrap overflow-auto max-h-96">{result}</pre>
          </div>
        </div>
      )}
      
      <div className="mt-6 p-4 bg-yellow-50 border border-yellow-300 rounded">
        <h2 className="font-bold">CORS Analysis:</h2>
        <ul className="list-disc pl-5 mt-2">
          <li>If CORS errors appear, the WordPress server doesn't allow access from different domains</li>
          <li>If data is returned, you can use API or iframe for embedding</li>
          <li>Note: Cross-origin requests cannot automatically send cookies from WordPress</li>
        </ul>
      </div>
    </div>
  );
};

export default TestCorsRequest;
